import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, memo, } from 'react';
import theme from '../../styles/theme';
import { ButtonPickerContext } from './ButtonPickerContext';
import { layouts, sizes, } from './constants';
const defaultProps = {
    layout: layouts.horizontalLayout,
    onChange: () => { },
    size: sizes.medium,
    value: '',
};
const ButtonPicker = ({ children, layout = defaultProps.layout, name, onChange = defaultProps.onChange, size = defaultProps.size, value = defaultProps.value, }) => {
    const wrapperStyles = css `
    display: flex;
    ${layout === layouts.gridLayout && css `
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    `}
    ${layout === layouts.horizontalLayout && css `
      flex-direction: row;
      flex-wrap: wrap;
    `}
    ${layout === layouts.verticalLayout && css `
      flex-direction: column;
    `}
    row-gap: ${theme.spacing.x2};
    column-gap: ${theme.spacing.x2};
  `;
    const providerValue = useMemo(() => ({
        layout,
        onChange,
        pickerName: name,
        selectedValues: value,
        size,
    }), [
        layout,
        onChange,
        name,
        value,
        size,
    ]);
    return (_jsx("div", Object.assign({ css: wrapperStyles }, { children: _jsx(ButtonPickerContext.Provider, Object.assign({ value: providerValue }, { children: children })) })));
};
const MemoizedButtonPicker = memo(ButtonPicker);
export { MemoizedButtonPicker as ButtonPicker };
// MC-1068 Temporary hack for Storybook.
export default ButtonPicker;
